import { render, staticRenderFns } from "./OurLookupsList.vue?vue&type=template&id=35f5d64f&"
import script from "./OurLookupsList.vue?vue&type=script&lang=js&"
export * from "./OurLookupsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports